module.exports = __webpack_public_path__ + "static/bad-ux-chair-93cf89abbce05d93744c246cf4e0c902.png";